import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../../Store';
import ReactDOM from 'react-dom';
import { isApp, isBrowser, portalUri } from '../../../utils';
import BottomNav from '../../wrapper/BottomNav/BottomNav';

const FooterNav = (props) => {
    const [apiNavigationTop, setApiNavigationTop] = useState({});

    const fetchApiNavigationBottom = useCallback(async () => {
        const rawLayoutUri = props.config.config.layout_uri || props.config.config.promotion_uri;
        if (rawLayoutUri && !isApp()) {
            try {
                const layoutUrl = new URL(rawLayoutUri);
                const layoutDomainName = layoutUrl?.hostname;
                let result;
                const fetchUrl = `https://${layoutDomainName}/api/navigation/level/bottom`;
                if (layoutUrl?.username && layoutUrl?.password) {
                    result = await fetch(fetchUrl, {
                        headers: { Authorization: 'Basic ' + btoa(layoutUrl.username + ':' + layoutUrl.password) },
                    });
                } else {
                    result = await fetch(fetchUrl);
                }
                const jsonResult = await result.json();
                setApiNavigationTop(jsonResult);
            } catch (error) {
                console.error(error);
            }
        }
    }, [props.config.config.promotion_uri, setApiNavigationTop]);

    useEffect(() => {
        fetchApiNavigationBottom();
    }, [fetchApiNavigationBottom]);

    if (isBrowser()) {
        const navWrapper = document.getElementById('bottom-nav');
        return navWrapper ? ReactDOM.createPortal(<BottomNav {...{ portalUri, apiNavigationTop }} />, navWrapper) : null;
    } else {
        return null;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterNav);
